//Mobile Header
const mobileHeaderBtns = document.querySelectorAll(
  '[data-mobile-nav-btn]'
);
const mobileHeader = document.querySelector('#mobileHeader');
const childLinkContainers = document.querySelectorAll(
  '.mobile-navigation__child-links-container'
);

mobileHeaderBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    if (mobileHeader) {
      mobileHeader.classList.toggle('open');
      document
        .querySelector('body')
        .classList.toggle('overflow-hidden');
    }
    navigationInner.classList.add('active');
    setTimeout(() => {
      childLinkContainers.forEach(el => {
        el.classList.remove('active');
      });
    }, 300);
  });
});

/* Mobile Navigation */
const navigationInner = document.querySelector(
  '.mobile-navigation-inner'
);
const mobileNavBtns = document.querySelectorAll(
  '.mobile-navigation__link-container'
);

mobileNavBtns.forEach(btn => {
  btn.addEventListener('click', e => {
    const link = e.currentTarget.dataset.link;
    const childLinks = document.querySelector(
      `.mobile-navigation__child-links-container[data-link="${link}"]`
    );
    childLinks.classList.add('active');
    navigationInner.classList.remove('active');
  });
});

/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const stagger = document.querySelectorAll('.stagger');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (stagger.length > 0) {
  stagger.forEach(el => {
    el.querySelectorAll('.stagger-child').forEach((e, i) => {
      e.style.setProperty('--animation-order', i);
    });
  });
}

// SWIPER
const swiperProduct = new Swiper('#swiper-product', {
  direction: 'horizontal',
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-product-button-next',
    prevEl: '.swiper-product-button-prev'
  }
});

function initFeaturedBlogSwipers() {
  document.querySelectorAll('.featured-blog').forEach(section => {
    const swiperEl = section.querySelector('.swiper-featured-blog');
    const nextBtn = section.querySelector('.swiper-button-next');
    const prevBtn = section.querySelector('.swiper-button-prev');

    if (swiperEl && !swiperEl.swiper) {
      // prevent double init
      new Swiper(swiperEl, {
        direction: 'horizontal',
        slidesPerView: 1.2,
        spaceBetween: 12,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        loop: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          768: {
            slidesPerView: 3.5,
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16
          }
        }
      });
    }
  });
}

// Run on normal load
document.addEventListener(
  'DOMContentLoaded',
  initFeaturedBlogSwipers
);

// Support Shopify Theme Editor live reloads
document.addEventListener(
  'shopify:section:load',
  initFeaturedBlogSwipers
);
document.addEventListener(
  'shopify:section:unload',
  initFeaturedBlogSwipers
);

const swiperFeaturedCollection = new Swiper(
  '#swiper-featured-collection',
  {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 12,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  }
);

const swiperProductRecommendations = new Swiper(
  '#swiper-product-recommendations',
  {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 12,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 48,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  }
);

var swiperTestimonialsCarousel = new Swiper(
  '.swiper-testimonials-carousel',
  {
    direction: 'horizontal',
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-testimonials-carousel-button-next',
      prevEl: '.swiper-testimonials-carousel-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 60
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 75
      }
    }
  }
);

// NAVIGATION MOBILE
const menuItemsMobile = document.querySelectorAll(
  '#headerMenuItemMobile.has-children'
);

menuItemsMobile.forEach(item => {
  const toggleLink = item.querySelector('a');
  const childLinks = item.querySelector(
    '.navigation__child-links-mobile'
  );

  if (toggleLink && childLinks) {
    toggleLink.addEventListener('click', e => {
      e.preventDefault(); // prevent jumping to "#" links

      const isActive = item.classList.contains('active');

      // Close all others (optional, for accordion behaviour)
      document
        .querySelectorAll('#headerMenuItemMobile.active')
        .forEach(openItem => {
          openItem.classList.remove('active');
          const openChild = openItem.querySelector(
            '.navigation__child-links-mobile'
          );
          if (openChild) openChild.style.maxHeight = null;
        });

      // Toggle this one
      if (!isActive) {
        item.classList.add('active');
        childLinks.style.maxHeight = childLinks.scrollHeight + 'px';
      } else {
        item.classList.remove('active');
        childLinks.style.maxHeight = null;
      }
    });
  }
});
// END OF NAVIGATION MOBILE

// NAVIGATION
const navigation = document.querySelector('#navigation');
const headerWrapper = document.querySelector('header');
const menuItems = Array.from(
  document.querySelectorAll('#headerMenuItem')
);
const childLinks = document.querySelectorAll(
  '.navigation__child-link'
);
const columnHeadings = document.querySelectorAll(
  '.navigation__column-heading'
);

menuItems.forEach(item => {
  item.addEventListener('mouseenter', e => {
    const navItem = item.dataset.navItem;

    navigation.classList.remove('active');
    headerWrapper.classList.remove('nav-active');
    menuItems.forEach(menuItem =>
      menuItem.classList.remove('active')
    );
    document.querySelectorAll('#navChildMenu.active').forEach(el => {
      el.classList.remove('active');
    });

    if (item.classList.contains('has-children')) {
      const childLink = document.querySelector(
        `#navChildMenu[data-nav-item="${navItem}"]`
      );

      if (childLink) {
        childLink.classList.add('active');
        item.classList.add('active');
        navigation.classList.add('active');
        headerWrapper.classList.add('nav-active');
      }
    }
  });
});

navigation.addEventListener('mouseleave', () => {
  navigation.classList.remove('active');
  headerWrapper.classList.remove('nav-active');
  menuItems.forEach(menuItem => menuItem.classList.remove('active'));
  childLinks.forEach(child => child.classList.remove('active'));
  document
    .querySelectorAll('.navigation__sub-links.active')
    .forEach(subList => {
      subList.classList.remove('active');
      subList.style.maxHeight = null;
    });
});

columnHeadings.forEach(heading => {
  heading.addEventListener('click', e => {
    const parent = heading.parentElement;
    const subList = parent.querySelector('.navigation__sub-links');

    if (subList) {
      e.preventDefault();

      const isOpen = subList.classList.contains('active');

      document
        .querySelectorAll('.navigation__sub-links.active')
        .forEach(list => {
          list.classList.remove('active');
          list.style.maxHeight = null;
        });

      if (!isOpen) {
        subList.classList.add('active');
        subList.style.maxHeight = subList.scrollHeight + 'px';
      }
    }
  });
});
// END OF NAVIGATION

// MOBILE VIEWPORT HEIGHT FIX
(() => {
  if (
    CSS.supports('height', '100svh') ||
    CSS.supports('height', '100dvh')
  ) {
    // Browser supports modern units, no need for JS
    return;
  }

  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Optional: update on resize/orientation change
  window.addEventListener('resize', () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
})();

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

// Retailers Filter
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll(
    '.retailer-filter [data-id]'
  );
  const sections = document.querySelectorAll('.retailers[data-id]');
  if (!buttons.length || !sections.length) return;

  function setActiveButton(id) {
    buttons.forEach(btn =>
      btn.classList.toggle(
        'active',
        (btn.getAttribute('data-id') || '').toLowerCase() === id
      )
    );
  }

  function setActiveSection(id) {
    sections.forEach(section => {
      const match =
        (section.getAttribute('data-id') || '').toLowerCase() === id;

      if (id === 'all') {
        // show all, but remove any "active"
        section.classList.remove('is-hidden');
        section.classList.remove('active');
      } else {
        // show only the matching one, and mark it active
        section.classList.toggle('is-hidden', !match);
        section.classList.toggle('active', match);
      }
    });
  }

  function showAll() {
    setActiveSection('all');
    setActiveButton('all');
  }

  function activateById(id) {
    const key = (id || 'all').toLowerCase();
    if (key === 'all') return showAll();

    setActiveSection(key);
    setActiveButton(key);
  }

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const id = button.getAttribute('data-id') || 'all';
      activateById(id);

      if (id === 'all') {
        history.replaceState(
          null,
          '',
          location.pathname + location.search
        );
      } else {
        history.replaceState(null, '', `#${id}`);
      }
    });
  });

  // Initial state
  const validIds = Array.from(buttons).map(btn =>
    (btn.getAttribute('data-id') || '').toLowerCase()
  );
  const hash = (
    window.location.hash.replace('#', '') || ''
  ).toLowerCase();

  if (hash && validIds.includes(hash) && hash !== 'all') {
    activateById(hash);
  } else {
    showAll();
  }

  // Back/forward sync
  window.addEventListener('hashchange', () => {
    const newHash = (
      window.location.hash.replace('#', '') || ''
    ).toLowerCase();
    if (!newHash || newHash === 'all') showAll();
    else if (validIds.includes(newHash)) activateById(newHash);
  });
});
// End of Retailers Filter

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');

  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);

  if (quantity == '+') {
    Number(formQ.value++);
  } else if (quantity == '-' && formQ.value > 1) {
    Number(formQ.value--);
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator */
const details = document.querySelectorAll('details');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', function (e) {
      if (targetDetail.hasAttribute('open')) {
        e.preventDefault();
        targetDetail.classList.add('closing');
        setTimeout(() => {
          targetDetail.removeAttribute('open');
          targetDetail.classList.remove('closing');
        }, 390);
      }
    });
  });
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'a',
  'span'
];
var nbspWordMin = 10; //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
//   var nbspElements = document.querySelectorAll(selector);
//   nbspElements.forEach(function (element) {
//     element.innerHTML = element.innerHTML.replace(/\u2028/g, '');
//     element.innerHTML = element.innerHTML.replace(/&#8232;/g, '');
//     var wordCount = element.innerHTML.split(' ').length;
//     if (wordCount >= nbspWordMin) {
//       element.innerHTML = element.innerHTML.replace(
//         / ([^ ]*)$/,
//         '&nbsp;$1'
//       );
//     }
//   });
// });

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'Adding';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');

if (llVideos.length > 0) {
  enterView({
    selector: '.video-ll',
    enter: function (el) {
      el.load();
      el.play();
    },
    offset: 0.1
  });
}

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', handleAccountPageNav);
window.addEventListener('hashchange', handleAccountPageNav);

// Header homepage + Story page scroll animation and loaded class
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');
  const body = document.body;

  // Match homepage or story page
  const isTransparentHeaderPage =
    body.classList.contains('template--home') ||
    body.classList.contains('template--story');

  if (!header || !isTransparentHeaderPage) return;

  header.classList.add('transparent-header');

  setTimeout(() => {
    header.classList.add('loaded');
  }, 100);

  const handleScroll = () => {
    if (window.scrollY > 150) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.packaging-option').forEach(link => {
    link.addEventListener('click', () => {
      sessionStorage.setItem('scrollPos', window.scrollY);
    });
  });

  const scrollPos = sessionStorage.getItem('scrollPos');
  if (scrollPos) {
    window.scrollTo({
      top: parseInt(scrollPos, 10),
      behavior: 'instant'
    });
    sessionStorage.removeItem('scrollPos');
  }
});

// UPDATES CART COUNT IN HEADER
document.addEventListener('DOMContentLoaded', () => {
  const countElem = document.querySelector('[data-cart-count]');
  if (!countElem) return;

  function updateCartCount(cart) {
    const count = cart?.item_count || 0;
    countElem.textContent = count;
  }

  // Main Shopify Ajax Cart event (fires on add, remove, quantity change)
  document.addEventListener('ajaxCart:updated', event => {
    updateCartCount(event.detail.cart);
  });

  // Fallback for alternate naming (some builds use this instead)
  document.addEventListener('ajaxCart:cartRequestComplete', event => {
    updateCartCount(event.detail.cart);
  });

  // Safety fallback if neither fires
  document.body.addEventListener('click', e => {
    if (e.target.closest('[data-ajax-cart-request-button]')) {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(updateCartCount);
      }, 500);
    }
  });

  // Also listen for normal add-to-cart form submissions
  document.body.addEventListener('submit', e => {
    if (e.target.matches('form[action="/cart/add"]')) {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(updateCartCount);
      }, 800);
    }
  });
});

// DISCOUNT CODE HANDLER - AUTO ADD FREE PRODUCT
let isInitializing = false;
let lastInitTime = 0;
let priceOverrideTimeout = null;

function initializeDiscountCode() {
  // Prevent re-initialization if already running or ran recently
  const now = Date.now();
  if (isInitializing || (now - lastInitTime) < 200) {
    return;
  }

  isInitializing = true;
  lastInitTime = now;

  const applyBtn = document.getElementById('apply-discount-btn');
  const discountInput = document.getElementById('discount-code-input');
  const discountMessage = document.getElementById('discount-message');

  // Function to apply discount code to all checkout buttons
  function applyDiscountToCheckout(code) {
    if (!code) return;

    const checkoutButtons = document.querySelectorAll('button[name="checkout"], a[href*="checkout"], form[action*="checkout"] button[type="submit"]');

    checkoutButtons.forEach((btn, index) => {
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      };
    });

    const checkoutForms = document.querySelectorAll('form[action*="/cart"]');
    checkoutForms.forEach((form) => {
      form.onsubmit = function(e) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      };
    });
  }

  // Debounced function to override prices when OASISGIFT is applied
  function overrideOasisGiftPrices() {
    // Clear any pending price override
    if (priceOverrideTimeout) {
      clearTimeout(priceOverrideTimeout);
    }

    // Schedule a new price override - wait for browser to finish rendering
    priceOverrideTimeout = setTimeout(() => {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          applyPriceOverride();
        });
      });
    }, 300);
  }

  // Function to actually apply the price override
  function applyPriceOverride() {

    // Get current cart data to find the free product
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        // Check for duplicate items in DOM and trigger refresh if found
        const cartItemsContainer = document.querySelector('.cart-modal__items');
        if (cartItemsContainer) {
          const allItems = cartItemsContainer.querySelectorAll('.cart-modal__item');

          if (allItems.length > cart.items.length) {
            console.warn('[Discount Code] WARNING: DOM has more items than cart data! Triggering refresh to consolidate duplicates...');

            // Trigger a cart refresh to force Liquid Ajax Cart to re-render and consolidate
            if (typeof liquidAjaxCart !== 'undefined' && liquidAjaxCart.cartRequestGet) {
              setTimeout(() => {
                liquidAjaxCart.cartRequestGet();
              }, 1000);
            }
            return; // Exit early, let the refresh handle it
          }
        }

        // Find the free product (variant ID: 49755665662282)
        const freeProduct = cart.items.find(item => item.variant_id === 49755665662282 || item.id === 49755665662282);

        if (!freeProduct) {
          return;
        }

        const unitPrice = freeProduct.price; // Price per single item
        const quantity = freeProduct.quantity;

        // Only one item is free - calculate price for (quantity - 1) items
        const adjustedLinePrice = unitPrice * (quantity - 1);

        // Find and update the free product's line price display
        // ONLY update the FIRST occurrence to handle duplicate rendering gracefully
        const cartItems = document.querySelectorAll('.cart-modal__item, .cart__item');
        let modifiedCount = 0;

        cartItems.forEach(item => {
          const titleElement = item.querySelector('a[href*="' + freeProduct.handle + '"]');

          if (titleElement) {
            const priceElement = item.querySelector('.cart-modal__item-price p, .cart__item-price p');

            // Check if this item was already modified (has our marker attribute)
            const alreadyModified = item.hasAttribute('data-discount-applied');

            if (priceElement && !alreadyModified && modifiedCount === 0) {
              // Only update the FIRST unmodified free product item found
              modifiedCount++;
              item.setAttribute('data-discount-applied', 'true');
              if (quantity === 1) {
                // If only 1 item, show £0
                priceElement.textContent = '£0.00';
              } else {
                // If multiple items, show price for (quantity - 1) items
                const adjustedPriceFormatted = '£' + (adjustedLinePrice / 100).toFixed(2);
                priceElement.textContent = adjustedPriceFormatted;
              }
            } else if (priceElement && (alreadyModified || modifiedCount > 0)) {
              // Leave other duplicates at full price - cart will consolidate later
            }
          }
        });
      })
      .catch(error => {
        console.error('[Discount Code] Error overriding prices:', error);
      });
  }

  // Check cart and clear discount if cart is empty or free product not in cart
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const storedCode = sessionStorage.getItem('appliedDiscountCode');

      // Clear discount if cart is empty
      if (cart.item_count === 0) {
        sessionStorage.removeItem('appliedDiscountCode');
        return;
      }

      // Clear discount if free product is not in cart (OASISGIFT only)
      if (storedCode === 'OASISGIFT') {
        const hasFreeProduct = cart.items.some(item =>
          item.variant_id === 49755665662282 || item.id === 49755665662282
        );

        if (!hasFreeProduct) {
          sessionStorage.removeItem('appliedDiscountCode');
          return;
        }

        // Check if there are other products besides the free gift
        const otherProducts = cart.items.filter(item =>
          item.variant_id !== 49755665662282 && item.id !== 49755665662282
        );

        if (otherProducts.length === 0) {
          sessionStorage.removeItem('appliedDiscountCode');

          // Restore the free product's price to its original value
          const freeProduct = cart.items.find(item =>
            item.variant_id === 49755665662282 || item.id === 49755665662282
          );

          if (freeProduct) {
            const cartItems = document.querySelectorAll('.cart-modal__item, .cart__item');
            cartItems.forEach(item => {
              const titleElement = item.querySelector('a[href*="' + freeProduct.handle + '"]');
              if (titleElement) {
                const priceElement = item.querySelector('.cart-modal__item-price p, .cart__item-price p');
                if (priceElement) {
                  // Restore to original line price
                  const originalPrice = '£' + (freeProduct.final_line_price / 100).toFixed(2);
                  priceElement.textContent = originalPrice;
                }
              }
            });

            // Restore the cart total to its original value
            const totalPriceElements = document.querySelectorAll('.cart-modal__footer .cart__price-details p:last-child');
            totalPriceElements.forEach(el => {
              const originalTotal = '£' + (cart.total_price / 100).toFixed(2);
              el.textContent = originalTotal;
            });
          }

          // Show input, button, and header again
          if (discountInput) {
            discountInput.style.display = '';
          }
          const applyButton = document.getElementById('apply-discount-btn');
          if (applyButton) {
            applyButton.style.display = '';
          }
          const discountLabel = document.querySelector('label[for="discount-code-input"]');
          if (discountLabel) {
            discountLabel.style.display = '';
          }
          const discountHeader = document.querySelector('.cart-modal__discount-header');
          if (discountHeader) {
            discountHeader.style.display = '';
          }

          // Clear the discount message
          if (discountMessage) {
            discountMessage.textContent = '';
            discountMessage.className = 'cart-modal__discount-message';
          }

          return;
        }

        // If OASISGIFT discount is still valid, apply price override
        setTimeout(() => {
          overrideOasisGiftPrices();
        }, 200);
      }

      // Apply any stored discount code to checkout (OASISGIFT or other codes)
      if (storedCode) {
        applyDiscountToCheckout(storedCode);

        // Show appropriate message based on code type
        if (discountMessage) {
          if (storedCode === 'OASISGIFT') {
            discountMessage.textContent = `✓ Code "${storedCode}" applied`;
          } else {
            discountMessage.textContent = `✓ Code "${storedCode}" will be applied at checkout`;
          }
          discountMessage.className = 'cart-modal__discount-message cart-modal__discount-message--success';
        }

        // Hide input, button, and header since code is already applied
        if (discountInput) {
          discountInput.style.display = 'none';
        }
        const applyButton = document.getElementById('apply-discount-btn');
        if (applyButton) {
          applyButton.style.display = 'none';
        }
        const discountHeader = document.querySelector('.cart-modal__discount-header');
        if (discountHeader) {
          discountHeader.style.display = 'none';
        }
      }
    })
    .catch(error => {
      console.error('[Discount Code] Error checking cart:', error);
    });

  if (!applyBtn || !discountInput) {
    isInitializing = false;
    return;
  }

  // Remove existing listeners to prevent duplicates
  const newApplyBtn = applyBtn.cloneNode(true);
  applyBtn.parentNode.replaceChild(newApplyBtn, applyBtn);


  newApplyBtn.addEventListener('click', async () => {
    const code = discountInput.value.trim().toUpperCase();

    if (!code) {
      showMessage('Please enter a discount code', 'error');
      return;
    }


    // Check if there are other products in cart (not just the free gift)
    try {
      const cartData = await fetch('/cart.js').then(r => r.json());
      const otherProducts = cartData.items.filter(item =>
        item.variant_id !== 49755665662282 && item.id !== 49755665662282
      );

      if (otherProducts.length === 0) {
        showMessage('Please add a product to your cart first', 'error');
        return;
      }

    } catch (error) {
      console.error('[Discount Code] Error checking cart:', error);
      showMessage('Unable to validate cart', 'error');
      return;
    }

    // Check if code is valid (only OASISGIFT is accepted)
    if (code !== 'OASISGIFT') {
      showMessage('Invalid code - If you’re trying to use a discount code, proceed to checkout and use it there instead.', 'error');
      return;
    }

    // Disable button and show loading state
    applyBtn.disabled = true;
    const originalText = applyBtn.textContent;
    applyBtn.textContent = 'Applying...';
    applyBtn.style.opacity = '0.6';
    applyBtn.style.cursor = 'not-allowed';
    discountInput.disabled = true;

    try {
      // Use Liquid Ajax Cart's API (this auto-updates sections)
      if (typeof liquidAjaxCart !== 'undefined' && liquidAjaxCart.cartRequestAdd) {

        // Only add free product for OASISGIFT code
        if (code === 'OASISGIFT') {
          showMessage('Adding free product...', 'info');

          const addResult = await liquidAjaxCart.cartRequestAdd({
            items: [
              {
                id: '49755665662282',
                quantity: 1
              }
            ]
          });


          // Get updated cart data
          const cartData = await fetch('/cart.js').then(r => r.json());
          const countElem = document.querySelector('[data-cart-count]');
          if (countElem && cartData) {
            countElem.textContent = cartData.item_count;
          }
        }

        showMessage('Applying code...', 'info');

        // Apply discount code to cart by updating cart attributes
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Discount Code': code
            }
          })
        });

        const updateData = await updateResponse.json();

        // Store discount code in session storage for persistence
        sessionStorage.setItem('appliedDiscountCode', code);

        // Apply discount to all checkout buttons
        applyDiscountToCheckout(code);

        // Show clear message about checkout application
        if (code === 'OASISGIFT') {
          showMessage(`✓ Code "${code}" applied`, 'success');
        } else {
          showMessage(`Code ${code} will be applied at checkout`, 'success');
        }

        // Hide the input, button, label, and header after successful application
        if (discountInput) {
          discountInput.style.display = 'none';
        }
        const applyButton = document.getElementById('apply-discount-btn');
        if (applyButton) {
          applyButton.style.display = 'none';
        }
        const discountLabel = document.querySelector('label[for="discount-code-input"]');
        if (discountLabel) {
          discountLabel.style.display = 'none';
        }
        const discountHeader = document.querySelector('.cart-modal__discount-header');
        if (discountHeader) {
          discountHeader.style.display = 'none';
        }

        // Wait for Liquid Ajax Cart sections to auto-update
        await new Promise(resolve => setTimeout(resolve, 600));

        // Apply price override after cart has refreshed (OASISGIFT only)
        if (code === 'OASISGIFT') {
          overrideOasisGiftPrices();
        }
      } else {
        console.error('[Discount Code] Liquid Ajax Cart not available, falling back');
        showMessage('Unable to apply discount', 'error');
      }
    } catch (error) {
      console.error('[Discount Code] Exception caught:', error);
      console.error('[Discount Code] Error stack:', error.stack);
      showMessage('Something went wrong. Please try again.', 'error');
    } finally {
      // Reset button state
      applyBtn.disabled = false;
      applyBtn.textContent = originalText;
      applyBtn.style.opacity = '1';
      applyBtn.style.cursor = 'pointer';
      discountInput.disabled = false;
    }
  });

  // Allow Enter key to submit
  discountInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      newApplyBtn.click();
    }
  });

  function showMessage(text, type) {
    if (!discountMessage) return;

    discountMessage.textContent = text;
    discountMessage.className = `cart-modal__discount-message cart-modal__discount-message--${type}`;
  }

  isInitializing = false;
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  initializeDiscountCode();
});

// Listen for when Liquid Ajax Cart finishes updating sections (not just state)
if (typeof liquidAjaxCart !== 'undefined') {
  // Use a less frequent update check to avoid interfering with rendering
  let lastUpdateTime = 0;

  liquidAjaxCart.subscribeToCartStateUpdate((_state) => {
    const now = Date.now();

    // Only process updates if enough time has passed (prevent rapid-fire updates)
    if (now - lastUpdateTime < 300) {
      return;
    }

    lastUpdateTime = now;

    // Re-initialize to attach event listeners to potentially new DOM elements
    setTimeout(() => {
      initializeDiscountCode();
    }, 100);

    // Reapply price override if OASISGIFT is active (heavily debounced)
    const storedCode = sessionStorage.getItem('appliedDiscountCode');
    if (storedCode === 'OASISGIFT') {
      overrideOasisGiftPrices();
    }
  });
}

// Re-initialize when body class changes (cart drawer opens)
document.body.addEventListener('click', (e) => {
  // Check if cart toggle button was clicked
  if (e.target.closest('[data-ajax-cart-toggle-class-button]') ||
      e.target.closest('[aria-label*="Cart"]') ||
      e.target.closest('.cart-icon')) {
    setTimeout(() => {
      initializeDiscountCode();
    }, 100);
  }
});
